import { render, staticRenderFns } from "./AccessPoints.vue?vue&type=template&id=1318196e&scoped=true&lang=pug&"
import script from "./AccessPoints.vue?vue&type=script&lang=ts&"
export * from "./AccessPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318196e",
  null
  
)

export default component.exports